export default  PIXI;